import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob, IJobType } from './jobs'
import { createTask_custom } from './taskCustom'
import { createTask_goToMachine } from './taskGoToMachine'
import { createTask_drink } from './taskDrink'

const type: IJobType = 'drink'
export const register = () => registerJob(type, runJob)

function runJob(job: IJob) {
  jobLogger.assertJobType(job, type)
  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    const f = (c: IMachine) =>
      c.data.type === 'water-cooler' && c.waterSupply > 0

    // Go to water cooler
    let task = createTask_goToMachine(m.i, m.j, f, true)
    job.tasks.push(task)

    // Drink
    task = createTask_drink()
    job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
// export function advanceJob_moveToStack(job: IJob) {}
